/* eslint-disable react/prop-types */
import React from "react";
import { Link } from "react-router-dom";

function OrderTabs({
  orderType,
  all = 0,
  waitingPayment = 0,
  onprogress = 0,
  delivering = 0,
  completed = 0,
  canceled = 0,
}) {
  return (
    <div className="pp-tags history-tags px-4 mb-0">
      <ul className="scrollbar-hide">
        <li className={orderType === "all" ? "active" : ""}>
          <Link 
            className={`${orderType === "all" ? "!bg-[var(--rose-violet-opacity)] !text-[var(--rose-violet)]" : ""}`}
            to="/history/all" id="order_history_view_all">Semua {all ? `(${all})` : ""}</Link>
        </li>
        <li className={orderType === "waiting-payment" ? "active" : ""}>
          <Link 
            className={`${orderType === "waiting-payment" ? "!bg-[var(--rose-violet-opacity)] !text-[var(--rose-violet)]" : ""}`}
            to="/history/waiting-payment">
            Menunggu Pembayaran {waitingPayment ? `(${waitingPayment})` : ""}
          </Link>
        </li>
        <li className={orderType === "on-process" ? "active" : ""}>
          <Link 
            className={`${orderType === "on-process" ? "!bg-[var(--rose-violet-opacity)] !text-[var(--rose-violet)]" : ""}`}
            to="/history/on-process">
            Sedang Diprocess {onprogress ? `(${onprogress})` : ""}
          </Link>
        </li>
        <li className={orderType === "delivering" ? "active" : ""}>
          <Link 
            className={`${orderType === "delivering" ? "!bg-[var(--rose-violet-opacity)] !text-[var(--rose-violet)]" : ""}`}
            to="/history/delivering" id="order_history_view_inprogress">
            Sedang Dikirim {delivering ? `(${delivering})` : ""}
          </Link>
        </li>
        <li className={orderType === "completed" ? "active" : ""}>
          <Link 
            className={`${orderType === "completed" ? "!bg-[var(--rose-violet-opacity)] !text-[var(--rose-violet)]" : ""}`}
            to="/history/completed" id="order_history_view_completed">
            Selesai {completed ? `(${completed})` : ""}
          </Link>
        </li>
        <li className={orderType === "canceled" ? "active" : ""}>
          <Link 
            className={`${orderType === "canceled" ? "!bg-[var(--rose-violet-opacity)] !text-[var(--rose-violet)]" : ""}`}
            to="/history/canceled" id="order_history_view_canceled">
            Dibatalkan {canceled ? `(${canceled})` : ""}
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default OrderTabs;
